import { TermCourseServant } from '../servants/term_course_servant';
import { IHash } from 'core-ts-types';
import { ISection } from '../../../interfaces/scheduler_interfaces';
import { ITermCourse } from '../../../interfaces/scheduler_interfaces';
import * as _4 from 'lodash4';
export class CourseFilters {
  constructor(private ngTermCourseServant: TermCourseServant) {}
  filterPlannedCourses(courses: ITermCourse[], term: number) {
    return _4.filter(courses, (course: ITermCourse) => {
      const plannedCourseId = _4.get(course, '_planned_course.id', -1);
      const planedCourseTerm = _4.get(course, '_planned_course.term', -1);
      return TermCourseServant.isCoursePlanned(course) && plannedCourseId > 0 && planedCourseTerm === term;
    });
  }
  filterScheduledCourses(courses: ITermCourse[]) {
    return _4.filter(courses, (course: ITermCourse) => this.ngTermCourseServant.isCourseScheduled(course));
  }
  filterUnscheduledCourses(courses: ITermCourse[]) {
    return _4.filter(courses, (course: ITermCourse) => !this.ngTermCourseServant.isCourseScheduled(course));
  }
}

angular.module('capability-ng-scheduler').service('ngCourseFilters', CourseFilters);



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/views/term_courses/filters/course_filters.ts